import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

class TrackedCta extends Component {
    onClick(ev, childClick) {
        const { eventName } = this.props;
        if (window && window.analytics) {
            // eslint-disable-next-line no-undef
            analytics.track(eventName, this.props.traits);
        }
        if (childClick) {
            childClick(ev);
        }
    }

    render() {
        const childrenWithProps = React.Children.map(this.props.children, child => {
            if (child) {
                const childClick = child.props.onClick;
                return React.cloneElement(child, { onClick: (ev) => this.onClick(ev, childClick) });
            }
            return <Fragment />;
        });
        return (
            <Fragment>
                {childrenWithProps}
            </Fragment>
        );
    }
}

TrackedCta.propTypes = {
    children: PropTypes.element.isRequired,
};

export default TrackedCta;
